var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPageNumber2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14H27C28.0609 14 29.0783 14.4214 29.8284 15.1716C30.5786 15.9217 31 16.9391 31 18V22C31 23.0609 30.5786 24.0783 29.8284 24.8284C29.0783 25.5786 28.0609 26 27 26H22V30H31V34H17V26C17 24.9391 17.4214 23.9217 18.1716 23.1716C18.9217 22.4214 19.9391 22 21 22H27V18H17V14ZM24 4C26.6264 4 29.2272 4.51732 31.6537 5.52241C34.0802 6.5275 36.285 8.00069 38.1421 9.85786C39.9993 11.715 41.4725 13.9198 42.4776 16.3463C43.4827 18.7728 44 21.3736 44 24C44 29.3043 41.8929 34.3914 38.1421 38.1421C34.3914 41.8929 29.3043 44 24 44C21.3736 44 18.7728 43.4827 16.3463 42.4776C13.9198 41.4725 11.715 39.9993 9.85786 38.1421C6.10714 34.3914 4 29.3043 4 24C4 18.6957 6.10714 13.6086 9.85786 9.85786C13.6086 6.10714 18.6957 4 24 4ZM24 8C19.7565 8 15.6869 9.68571 12.6863 12.6863C9.68571 15.6869 8 19.7565 8 24C8 28.2435 9.68571 32.3131 12.6863 35.3137C15.6869 38.3143 19.7565 40 24 40C28.2435 40 32.3131 38.3143 35.3137 35.3137C38.3143 32.3131 40 28.2435 40 24C40 19.7565 38.3143 15.6869 35.3137 12.6863C32.3131 9.68571 28.2435 8 24 8Z",
    fill: "#2F4C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageNumber2);
export default __webpack_public_path__ + "static/media/landing_page_number_2.3cccb5c8f4c18a88772382f5aa0ac64b.svg";
export { ForwardRef as ReactComponent };